import { Box } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import type { FC } from 'react';

import Button from 'components/Button';
import StatusMessageBox from 'components/StatusMessageBox';

export interface MessageSuccessProps {
  onClose: () => void;
}

const MessageSuccess: FC<MessageSuccessProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleClose = (): void => {
    onClose();
  };

  return (
    <Box>
      <StatusMessageBox
        margin="0px"
        type="success"
        message={t(
          'common:pages.general_settings.report_problem_modal.report_sent',
        )}
        description={t(
          'common:pages.general_settings.report_problem_modal.success_description',
        )}
      />
      <Button
        variant="text"
        fullWidth
        size="large"
        onClick={handleClose}
        data-testid="modal-confirm-close"
        sx={{ marginTop: 5 }}
      >
        {t('common:pages.general_settings.change_password_modal.close')}
      </Button>
    </Box>
  );
};

export default MessageSuccess;
